const ScrollToAnchor = () => {
  const anchors = document.querySelectorAll('a[href^="#"]');

  if (anchors.length > 0) {
    anchors.forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        const targetId = anchor.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const headerHeight = document.querySelector(".header").offsetHeight;
          targetElement.style.scrollMarginTop = `${headerHeight}px`;
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }
};

export default ScrollToAnchor;
